import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {SwiperModule} from 'swiper/angular';

import {DirectivesModules} from '../shared/directives/directives.module';

import {ComponentsModules} from '../shared/components/components.module';
import {MovieCollectComponent} from './movie-collect.component';
import {MovieCollectRoutingModule} from './movie-collect-routing.module';
import {MovieSearchComponent} from './movie-search/movie-search.component';
import { DialectMovieComponent } from './dialect-movie/dialect-movie.component';
import {PipesModules} from "../shared/pipes/pipes.modules";


@NgModule({
  declarations: [
    MovieCollectComponent,
    MovieSearchComponent,
    DialectMovieComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    PipesModules,
    DirectivesModules,
    MovieCollectRoutingModule,
    ComponentsModules,
  ],
  providers: [
  ],
  exports: [
  ],
})
export class MovieCollectModule {}
